import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c(
        VLayout,
        {
          staticClass: "ma-5",
          attrs: { "justify-center": "", "align-center": "" }
        },
        [
          _c(VProgressCircular, {
            attrs: { indeterminate: "", color: "primary", size: "48" }
          })
        ],
        1
      )
    : _c("router-view")
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }